import { API_BASE_URL } from './constants';

const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);

const normalizeBaseUrl = (value) => String(value || '').replace(/\/+$/, '');

export const resolveUserAvatar = (value) => {
  if (!value) return '/assets/images/users/user.jpeg';
  const raw = String(value);
  if (isAbsoluteUrl(raw) || raw.startsWith('data:')) return raw;

  const normalized = raw.replace(/^\/+/, '');
  const isFilenameOnly = !normalized.includes('/');
  if (isFilenameOnly) {
    const baseSource =
      process.env.PUBLIC_URL && isAbsoluteUrl(process.env.PUBLIC_URL)
        ? process.env.PUBLIC_URL
        : API_BASE_URL || '';
    const base = normalizeBaseUrl(baseSource);
    const folder = normalized.startsWith('profile-') ? 'uploads/profiles' : 'uploads/profile';
    return base ? `${base}/${folder}/${normalized}` : `/${folder}/${normalized}`;
  }
  if (normalized.startsWith('uploads/')) {
    const baseSource =
      process.env.PUBLIC_URL && isAbsoluteUrl(process.env.PUBLIC_URL)
        ? process.env.PUBLIC_URL
        : API_BASE_URL || '';
    const base = normalizeBaseUrl(baseSource);
    return base ? `${base}/${normalized}` : `/${normalized}`;
  }

  return `/${normalized}`;
};

export default resolveUserAvatar;
